import { customerCardStyles } from "@insite/content-library/Components/CustomerCard";
import { css } from "styled-components";

customerCardStyles.selectButton = {
    variant: "primary",
};
